import { endpoint } from '@shared/services/endpoint'
import useSWR from 'swr'

import { getRequest } from '../../shared/services/fetcher'

export function useAuth() {
  const { isAdmin, isLoggedIn, user } = window.auth

  const useGetProfile = () => {
    const { data, error, isLoading, isValidating, mutate } = useSWR<
      User,
      Error
    >(endpoint.frontend.USER.GET_PROFILE, getRequest)

    if (data) {
      window.auth.user = data
    }

    return { data, error, isLoading, isValidating, mutate }
  }

  return {
    getProfile: useGetProfile,
    isAdmin,
    isLoggedIn,
    user,
  }
}

export default useAuth
